module.exports = __webpack_public_path__ + "img/10551390_L.df9f11c4.png";